import station_store from "./station_store";
import information_card_store from "./information_card_store";
import dam_store from "./dam_store";
import diagram_store from "./diagram_store";
import equation_store from "./equation_store";
import main_config_store from "./main_config_store";
const store = {
    subscribers:{},
    stationStore: {...station_store},
    informationCardStore: {...information_card_store},
    diagramStore: {...diagram_store},
    damStore: {...dam_store},
    equationStore: {...equation_store},
    mainConfigStore: {...main_config_store},
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default store